import CredencialSumar from "./CredencialSumar";
export default CredencialSumar